<template>
  <div class="wrap">
    <el-row>
      <ul class="row mt20 clear_a">
        <el-col :span="8" :offset="5">
          <li class="col">
            <p>好评</p>
            <div>
              <textarea v-if="edit" v-model="goodTags" class="textarea"></textarea>
              <p v-if="!edit" v-for="(item,i) in goodArr" :key="i">{{item}}</p>
            </div>
          </li>
        </el-col>
        <el-col :span="8">
          <li class="col">
            <p>差评</p>
            <div>
              <textarea v-if="edit" v-model="badTags" class="textarea"></textarea>
              <p v-if="!edit" v-for="(item,i) in badArr" :key="i">{{item}}</p>
            </div>
          </li>
        </el-col>
      </ul>
    </el-row>
    <el-row>
      <el-col :span="10" :offset="5">
        <div class="tip clear_a">
          <div class="left mr10">
            <p>提示:</p>
          </div>
          <div class="right">
            <p>1. 每一次换行视为一条快捷评论</p>
            <p>2. 每条快捷评论不超过15字</p>
            <p>3. 好评与差评的快捷评论条数累计不超过15条</p>
            <p>4. 为了页面美观, 我们建议每条快捷评论不超过5个字, 累计快捷评论不超过10条</p>
            <p>5. 至少需要配置一条快捷评</p>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="btn">
      <el-button
        type="primary"
        class="mt20"
        icon="el-icon-edit"
        v-if="!edit"
        @click="editSetting"
      >编辑配置</el-button>
      <el-button type="primary" class="mt20" v-if="edit" @click="saveTags">保存</el-button>
      <el-button class="mt20" v-if="edit"  @click="edit =!edit">取消</el-button>
    </div>
  </div>
</template>
<script>
import * as api from "api/comment";
export default {
  data() {
    return {
      edit: false,
      goodTags: "",
      badTags: "",
      goodArr: [],
      badArr: [],
      btn: false
    };
  },
  methods: {
    async saveTags() {
      this.btn = true;
      let good = [];
      let bad = [];
      this.goodTags.split(/\n/).map((item) =>{
        if(item !== ''){
          good.push(item.trim())
        }
      });
        this.badTags.split(/\n/).map((item) =>{
        if(item !== ''){
          bad.push(item.trim())
        }
      });
      let result = good.concat(bad);
      for (let i of result) {
        if (i.length > 15) {
          this.$message({
            message: "每条快捷评论不超过15字",
            type: "warning"
          }); 
          this.btn = false;
          break;
        }
      }
      if (result.length < 1) {
        this.$message({
          message: "至少需要配置一条快捷评论",
          type: "warning"
        });
        this.btn = false;
        return;
      }
      if (this.btn) {
        let result = await api.addAssessmentTag({
          badTags: bad,
          goodTags: good
        });
        if (result.code === 200) {
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.edit = false;
          this.badArr = [];
          this.goodArr = [];
          this.getTags();
        }
      }
    },
    editSetting() {
      this.goodTags = this.goodArr.join("\n");
      this.badTags = this.badArr.join("\n");
      this.edit = !this.edit;
    },
    async getTags() {
      let result = await api.getAssessmentTag();
      this.goodArr = result.data.goodTags;
      this.badArr = result.data.badTags;
    },
    checkTag() {}
  },
  mounted() {
    this.getTags();
  }
};
</script>
<style lang="scss" scoped>
.wrap {
  text-align: left;
  .tip {
    width: 600px;
    padding: 8px 16px;
    background-color: #ecf8ff;
    border-radius: 4px;
    border-left: 5px solid #50bfff;
    margin: 20px 0;
    > p {
      font-size: 14px;
      color: #5e6d82;
      line-height: 14px;
    }
  }
  .row {
    .col > p {
      font-size: 16px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 16px;
      margin-bottom: 20px;
    }
    .col > div {
      border: 1px solid #ebebeb;
      border-radius: 3px;
      width: 400px;
      height: 400px;
      padding: 15px;
      box-sizing: border-box;
    }
  }
  .textarea {
    width: 400px !important;
    height: 400px !important;
    font-size: 15px !important;
    line-height: 15px !important;
    color: #999999;
    outline: none;
    border: none !important;
  }
  .btn {
    position: fixed;
    bottom: 20px;
    right: 20px;
  }
}
</style>
